<template>
  <TemplateModal
    ref="modal"
    center
    width="500"
    empty
    :sendFunction="onSendFunction"
    externalActivator
  >
    <div class="w-100 d-grid gap-5">
      <template v-if="setting.action === 'info'">
        <ChatInfo :params="chatSelect" :chatTranslations="chatTranslations" />
        <div class="description" v-if="chatSelect && chatSelect.description">
          <div class="description__text">
            {{ chatSelect.description }}
          </div>
        </div>
        <div v-if="chatSelect.actionEnabled" class="d-flex gap-2 justify-space-between pa-2">
          <div class="d-flex gap-2">
            <BaseIcon color="#277FAF" icon="pages-settings-push_notifications" />
            {{ chatTranslations.notifications }}
          </div>
          <BaseInput
            type="switch"
            v-model="chatSelect.currentUser.isNotificationsEnabled"
            @input="onChangeChatNotification"
            :loading="chatChangeNotificationLoading"
          />
        </div>
        <button
          class="main_button"
          @click="onChangeAction('file-viewer')"
          :disabled="chatSelect.attachments ? chatSelect.attachments.count === 0 : true"
        >
          <BaseIcon
            color="#277FAF"
            :icon="chatSelect.attachments ? 'pages-documents' : 'loader-clock'"
          />
          {{
            localStorage.translations.pages.common.text.attachments +
            ': ' +
            (chatSelect.attachments ? chatSelect.attachments.count : '0')
          }}
        </button>
        <button
          v-if="userIsAdminChat && isTypeGroup && !chatSelect.metadata"
          @click.prevent="onChangeAction()"
          class="main_button"
        >
          <BaseIcon color="#277FAF" icon="pages-settings" />
          {{ chatTranslations.group_settings }}
        </button>
      </template>
      <template v-else-if="setting.action === 'file-viewer'">
        <h4 class="f24 mb-5">
          {{
            localStorage.translations.pages.common.text.attachments +
            ': (' +
            chatSelect.attachments.data.length +
            ' ' +
            localStorage.translations.pages.common.pagination['iz'] +
            ' ' +
            chatSelect.attachments.count +
            ')'
          }}
        </h4>
        <div class="d-grid gap-2 list__body" @scroll="attachmentsScroll">
          <BaseFileView
            v-for="(file, fileKey) in chatSelect.attachments.data"
            :key="fileKey"
            :itemKey="fileKey"
            :items="chatSelect.attachments.data"
            isRead
            :needApiDomain="chatApiDomain + '/static'"
            isFileList
          />
          <Loaders v-if="loadingData" fixed />
        </div>
      </template>
      <template v-else>
        <h4
          class="f30 mb-5"
          v-if="!(isTypeGroup && (setting.action === 'create' || setting.action === 'edit'))"
        >
          {{
            isTypeGroup
              ? setting.action === 'participant-remove'
                ? chatTranslations.group_participants
                : setting.action === 'participant-add'
                ? chatTranslations.participant_add
                : chatTranslations.group_settings
              : chatTranslations.select_recipient
          }}
        </h4>
        <div
          v-if="!isTypeGroup && setting.action === 'create'"
          class="d-flex gap-2 justify-space-between px-2"
        >
          <div class="d-flex gap-2">
            <!-- <BaseIcon color="#277FAF" icon="pages-settings-push_notifications" /> -->
            {{ chatTranslations.several_recipients }}
          </div>
          <BaseInput type="switch" v-model="severalRecipients" />
        </div>
        <template v-if="isTypeGroup && (setting.action === 'create' || setting.action === 'edit')">
          <div class="mb-4 d-grid justify-self-start gap-4 align-center grid-col-max-1">
            <!-- <BaseButton default_icon="button-photo" icon_only round size="78" /> -->
            <ChatModalGroupPicture v-model="picture" />
            <BaseInput
              class="f18"
              v-model="title"
              :rules="['required']"
              :label="chatTranslations.group_name"
              max-width="100%"
            />
          </div>
          <BaseInput
            class="f18"
            v-model="description"
            :label="chatTranslations.description"
            type="textarea"
            max-width="100%"
          />
        </template>
        <Search v-model="search" max-width="100%" />
      </template>
      <div
        class="list"
        v-if="
          !(setting.type === 'PERSONAL' && setting.action === 'info') &&
          setting.action !== 'file-viewer'
        "
      >
        <button
          class="list__header primary white--text d-flex justify-space-between pa-2 align-center"
          :class="{ 'list__header--clickable': isDialogEdit }"
          @click="isDialogEdit && onChangeAction('file-viewer')"
          :disabled="!isDialogEdit"
          type="button"
        >
          {{
            `${
              setting.type === 'SHARE'
                ? chatTranslations.chat
                : localStorage.translations.pages.setting.pages['polzovateli']
            } (${
              isDialogSelectUsers
                ? (commonUserSearch &&
                    commonUserSearch.data.length +
                      ' ' +
                      localStorage.translations.pages.common.pagination['iz'] +
                      ' ' +
                      (commonUserSearch.amount || 0)) ||
                  ''
                : setting.type === 'SHARE'
                ? chatsListFormat.length +
                  ' ' +
                  localStorage.translations.pages.common.pagination['iz'] +
                  ' ' +
                  chats.filter(
                    (i) =>
                      (i.type === 'PERSONAL' ? !i.interlocutorUser.user.isUserDelete : true) &&
                      i.id !== $route.params.id,
                  ).length
                : usersListFormat.length
            })`
          }}
          <BaseIcon v-if="isDialogEdit" icon="button-edit" />
        </button>
        <div
          class="list__body"
          :class="{ 'list__body--empty': currentListItems.length === 0 }"
          @scroll="handleScroll"
        >
          <template v-if="currentListItems && currentListItems.length">
            <ChatModalListItem
              :itemData="item"
              v-for="(item, itemKey) in currentListItems"
              :key="itemKey"
              :setting="setting"
              :chatSelect="chatSelect"
              @closeModal="onCloseModal"
              :chats="chats"
              v-model="selectUser"
              :severalRecipients="severalRecipients"
              :chatTranslations="chatTranslations"
            />
          </template>
          <Plug
            v-else-if="currentListItems && currentListItems.length === 0 && !loadingData"
            fontSize="30"
            iconWidth="200px"
          />
          <Loaders v-if="loadingData" fixed />
        </div>
      </div>
      <div
        class="d-flex justify-center gap-5"
        v-if="
          (isTypeGroup &&
            (setting.action === 'info' ||
              setting.action === 'edit' ||
              setting.action === 'create' ||
              setting.action === 'participant-add' ||
              setting.action === 'participant-remove')) ||
          setting.action === 'file-viewer'
        "
      >
        <BaseButton
          v-if="
            setting.action === 'edit' ||
            setting.action === 'participant-remove' ||
            setting.action === 'participant-add' ||
            setting.action === 'file-viewer'
          "
          :text="localStorage.translations.pages.common.buttons.nazad"
          default_icon="button-back"
          @click="onChangeAction()"
        />
        <BaseButton
          v-if="setting.action !== 'info' && setting.action !== 'file-viewer'"
          :text="
            setting.action === 'participant-remove'
              ? localStorage.translations.pages.common.buttons.dobavit
              : localStorage.translations.pages.common.buttons.sohranit
          "
          :default_icon="setting.action === 'participant-remove' ? 'button-add' : 'button-save'"
          @click="
            setting.action === 'participant-remove'
              ? onChangeAction('participant-add')
              : onSendFunction()
          "
        />
      </div>
      <div
        class="d-flex justify-center gap-5"
        v-else-if="setting.action === 'create' && severalRecipients"
      >
        <ChatFilesUploadModal
          :chatTranslations="chatTranslations"
          :severalRecipients="selectUser"
          :chats="chats"
          @closeModal="onCloseModal"
        />
      </div>
      <template v-if="setting.action === 'info' && chatSelect.currentUser && !chatSelect.metadata">
        <button
          class="main_button"
          @click="$refs.deleteModal && $refs.deleteModal.openModal()"
          type="button"
        >
          <BaseIcon
            color="#EB5757"
            :icon="'button-' + (isTypeGroup ? (userIsAdminChat ? 'cross' : 'exit') : 'cross')"
          />
          {{
            isTypeGroup
              ? userIsAdminChat
                ? chatTranslations.group_remove
                : chatTranslations.group_leave
              : chatTranslations.chat_remove
          }}
        </button>
        <DeleteModal
          ref="deleteModal"
          :text="
            isTypeGroup
              ? (userIsAdminChat ? chatTranslations.group_remove : chatTranslations.group_leave) +
                '\n' +
                chatSelect.title
              : chatTranslations.chat_remove
          "
          :methodDelete="() => onDeleteChat()"
          :showBtn="false"
          :exit="isTypeGroup && !userIsAdminChat"
        />
      </template>
    </div>
  </TemplateModal>
</template>
<script>
import Search from 'components/Search.vue'
import ChatModalListItem from 'components/chat/modal/ChatModalListItem.vue'
import ChatInfo from 'components/chat/ChatInfo.vue'
import DeleteModal from 'components/DeleteModal.vue'
import Plug from 'components/Plug.vue'
import Loaders from 'components/Loaders.vue'
import ChatModalGroupPicture from 'components/chat/modal/ChatModalGroupPicture'
import ChatFilesUploadModal from 'components/chat/files/ChatFilesUploadModal'
import _ from 'lodash'
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  components: {
    Search,
    ChatModalListItem,
    ChatInfo,
    DeleteModal,
    Plug,
    Loaders,
    ChatModalGroupPicture,
    ChatFilesUploadModal,
  },
  name: 'ChatModal',
  props: {
    chatSelect: Object,
    usersList: Array,
    chats: Array,
    chatTranslations: Object,
  },
  data() {
    return {
      picture: null,
      title: '',
      description: null,
      search: '',
      setting: {
        type: null,
        action: null,
      },
      selectUser: [],
      loadingData: false,
      severalRecipients: false,
    }
  },
  computed: {
    ...mapState(['chatApiDomain']),
    ...mapGetters('user', ['userData']),
    ...mapState('commonUser', ['commonUserSearch']),
    ...mapState('chat', ['chatChangeNotificationLoading']),
    modal() {
      return this.$refs && this.$refs.modal
    },
    dialog() {
      return this.$refs.modal && this.$refs.modal.dialog
    },
    userIsAdminChat() {
      return this.chatSelect.currentUser && this.chatSelect.currentUser.isAdmin
    },
    isDialogCreate() {
      return this.setting.action === 'create'
    },
    isDialogSelectUsers() {
      return (
        (this.setting.action === 'create' || this.setting.action === 'participant-add') &&
        this.setting.type !== 'SHARE'
      )
    },
    isDialogEdit() {
      return this.setting.action === 'edit'
    },
    isTypeGroup() {
      return this.setting.type === 'GROUP'
    },
    exclusionFromTheListOfUsers() {
      switch (this.setting.action) {
        case 'participant-add':
          return this.chatSelect.participants.map((i) => {
            return i.userId
          })
        case 'create':
          return [this.userData.id]
        default:
          return []
      }
    },
    usersListFormat() {
      const regex = () => new RegExp(this.search, 'i')
      const participantsFind = (userId) =>
        this.chatSelect &&
        this.chatSelect.participants &&
        this.chatSelect.participants.find((i) => i.userId === userId)
      const userFullName = (user) => user.first_name + ' ' + user.last_name
      let result
      if (this.isDialogSelectUsers) {
        result = this.commonUserSearch.data
      } else {
        result = this.usersList
          .filter((user) => {
            const searchFilter = (value) =>
              value && (this.search.length ? userFullName(user).search(regex()) > -1 : true)
            let participant
            switch (this.setting.action) {
              case 'info':
              case 'edit':
              case 'participant-remove':
                participant = participantsFind(user.id)
                return searchFilter(
                  participant ? this.$set(user, 'participantData', participant) : false,
                )
              // case 'participant-add':
              //   participant = participantsFind(user.id)
              //   return searchFilter(participant ? false : true)
              // case 'create':
              //   if (user.participantData) {
              //     this.$delete(user, 'participantData')
              //   }
              //   return searchFilter(user.id !== this.userData.id)
              default:
                return true
            }
          })
          .sort((a, b) => {
            const sortAlphabetically = (a, b) => userFullName(a).localeCompare(userFullName(b))
            if (this.isTypeGroup && a.participantData && b.participantData) {
              if (b.participantData.isAdmin || a.participantData.isAdmin) {
                return b.participantData.isAdmin - a.participantData.isAdmin
              } else {
                return sortAlphabetically(a, b)
              }
            } else {
              return sortAlphabetically(a, b)
            }
          })
      }
      return result
    },
    chatsListFormat() {
      if (this.setting.type === 'SHARE') {
        const regex = new RegExp(this.search, 'i')
        return this.search.length
          ? this.chats.filter((i) => {
              return (
                (i.type === 'PERSONAL' ? !i.interlocutorUser.user.isUserDelete : true) &&
                i.displayData.name.search(regex) > -1
              )
            })
          : this.chats.filter(
              (i) =>
                (i.type === 'PERSONAL' ? !i.interlocutorUser.user.isUserDelete : true) &&
                i.id !== this.$route.params.id,
            )
      } else {
        return this.chats
      }
    },
    currentListItems() {
      return this.setting.type === 'SHARE' ? this.chatsListFormat : this.usersListFormat
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.$emit('close-dialog', true)
        this.onDefalutData()
      } else {
        // console.log('!this.commonUserSearch.search', !!this.commonUserSearch.search)
        if (
          this.isDialogCreate &&
          (!_.isEqual(this.commonUserSearch.ignoreIds, this.exclusionFromTheListOfUsers) ||
            this.commonUserSearch.search !== this.search ||
            !this.commonUserSearch.data.length)
        ) {
          this.GET_commonUserSearch({ ignoreIds: this.exclusionFromTheListOfUsers })
        } else if (this.setting.action === 'info') {
          this.GET_chatIdMedia({ chatId: this.chatSelect.id })
        }
      }
    },
    search() {
      if (this.isDialogSelectUsers && this.dialog) {
        this.GET_commonUserSearch({
          search: this.search,
          ignoreIds: this.exclusionFromTheListOfUsers,
        })
      }
    },
    'setting.action'() {
      if (
        this.setting.action === 'participant-add' &&
        (!_.isEqual(this.commonUserSearch.ignoreIds, this.exclusionFromTheListOfUsers) ||
          this.commonUserSearch.search !== this.search ||
          !this.commonUserSearch.data.length)
      ) {
        this.GET_commonUserSearch({ ignoreIds: this.exclusionFromTheListOfUsers })
      }
    },
  },
  methods: {
    ...mapActions('chat', [
      'CREATE_chatGroup',
      'EDIT_chatGroup',
      'ADD_chatGroupParticipant',
      'DELETE_chat',
      'LEAVE_chatGroup',
      'CHANGE_chatNotification',
      'GET_chatIdMedia',
    ]),
    ...mapActions('chat/file', ['POST_chatFile']),
    ...mapActions('commonUser', ['GET_commonUserSearch']),
    onOpen(setting) {
      Object.keys(setting).forEach((key) => {
        this.$data.setting[key] = setting[key]
      })
      this.$refs.modal.openModal()
    },
    onCloseModal() {
      this.$refs.modal.dialog = false
    },
    async onSendFunction() {
      // console.log('onSendFunction')
      if (this.$refs.modal.validate()) {
        if (this.isTypeGroup) {
          if (this.setting.action === 'create') {
            let data = {
              userIds: this.selectUser,
              title: this.title,
            }
            data.userIds.push(this.userData.id)
            if (this.picture && typeof this.picture !== 'string') {
              await this.POST_chatFile({ file: this.picture }).then((resp) => {
                data.pictureId = resp
              })
            }
            this.CREATE_chatGroup({ data }).then(() => {
              this.onCloseModal()
            })
          } else if (this.setting.action === 'edit') {
            let data = {
              id: this.$route.params.id,
            }
            if (this.title !== this.chatSelect.title) {
              data.title = this.title
            }
            if (this.description !== this.chatSelect.description && this.description !== '') {
              data.description = this.description
            }
            if (this.picture && typeof this.picture !== 'string') {
              await this.POST_chatFile({ file: this.picture }).then(
                (resp) => (data.pictureId = resp),
              )
            }
            if (Object.keys(data).length > 1) {
              // console.log('data', data)
              this.EDIT_chatGroup({ data }).then(() => {
                this.onChangeAction()
              })
            } else {
              this.onChangeAction()
            }
          } else if (this.setting.action === 'participant-add') {
            let data = {
              userIds: this.selectUser,
              chatId: this.chatSelect.id,
              isHistoryAvailable: true,
            }

            await this.ADD_chatGroupParticipant(data).then(() => {
              this.onChangeAction('edit')
            })
          }
        }
      }
    },
    onChangeAction(value) {
      let action
      if (value) {
        action = value
      } else {
        switch (this.setting.action) {
          case 'info':
            action = 'edit'
            this.title = this.chatSelect.title
            this.description = this.chatSelect.description
            this.picture = this.chatSelect.picture
            break
          case 'file-viewer':
          case 'edit':
            action = 'info'
            break
          case 'participant-add':
            action = 'participant-remove'
            break
          case 'participant-remove':
            action = 'edit'
            break
          default:
            action = 'edit'
        }
      }
      this.$set(this.setting, 'action', action)
      this.$nextTick(function () {
        let dialogContent = document.getElementsByClassName('v-dialog--active')[0]
        dialogContent.scroll({ top: 0 })
      })
    },
    onDefalutData() {
      // console.log('onDefalutData')
      this.title = ''
      this.description = null
      this.picture = null
      this.search = ''
      this.setting = {
        type: null,
        action: null,
      }
      this.selectUser = []
      this.severalRecipients = false
    },
    onDeleteChat() {
      // console.log('onDeleteChat')
      let data = {
        chatId: this.chatSelect.id,
      }
      if (!this.isTypeGroup) {
        data.isSoftDelete = false
      }
      this[
        this.isTypeGroup
          ? this.userIsAdminChat
            ? 'DELETE_chat'
            : 'LEAVE_chatGroup'
          : 'DELETE_chat'
      ](data).then(() => {
        this.onCloseModal()
      })
    },
    async onChangeChatNotification() {
      await this.CHANGE_chatNotification({
        chatId: this.chatSelect.id,
        useSwitch: true,
      })
    },
    handleScroll(e) {
      // console.log('handleScroll', e)
      // console.log('handleScroll', {
      //   scrollTop: e.target.scrollTop,
      //   scrollHeight: e.target.scrollHeight,
      //   clientHeight: e.target.clientHeight,
      //   target: e.target
      // })
      if (this.setting.type !== 'SHARE') {
        const scrollTopMax = e.target.scrollTopMax || e.target.scrollHeight - e.target.clientHeight
        if (
          e.target.scrollTop >= scrollTopMax - e.target.firstChild.scrollHeight &&
          this.commonUserSearch.currentPage < this.commonUserSearch.lastPage
        ) {
          // console.log('loadingData', this.loadingData)
          if (!this.loadingData) {
            this.loadingData = true
            this.GET_commonUserSearch({
              search: this.search,
              page: ++this.commonUserSearch.currentPage,
              ignoreIds: this.exclusionFromTheListOfUsers,
            }).finally(() => {
              this.loadingData = false
            })
          }
        }
      }
    },
    attachmentsScroll(e) {
      const scrollTopMax = e.target.scrollTopMax || e.target.scrollHeight - e.target.clientHeight
      if (
        e.target.scrollTop >= scrollTopMax - e.target.firstChild.scrollHeight &&
        this.chatSelect.attachments.count > this.chatSelect.attachments.data.length
      ) {
        // console.log('loadingData', this.loadingData)
        if (!this.loadingData) {
          this.loadingData = true
          this.GET_chatIdMedia({
            chatId: this.chatSelect.id,
          }).finally(() => {
            this.loadingData = false
          })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.list {
  border: 1px solid var(--v-secondary-lighten4);
  box-shadow: 0px 9px 10px rgba(239, 239, 239, 0.25);
  border-radius: 4px;
  &:only-child {
    border-bottom: 1px solid #000000;
  }
  &__header {
    transition: 0.3s;
    width: 100%;
    cursor: default;
    &--clickable {
      cursor: pointer;
      &:hover {
        background: var(--v-primary-darken1) !important;
      }
    }
  }
  &__body {
    position: relative;
    height: 330px;
    overflow-y: auto;
    overflow-x: hidden;
    &--empty {
      display: grid;
      align-items: center;
    }
  }
}
.main_button {
  display: grid;
  grid-template-columns: 24px 1fr;
  gap: 8px;
  padding: 8px;
  transition: 0.3s;
  text-align: start;
  align-items: center;
  svg {
    width: 100%;
    height: auto;
  }
  &:hover {
    background: var(--v-secondary-lighten4);
  }
}
.description {
  white-space: pre-line;
}
</style>
